import { adicionarTransacao } from '@constants/URL'
import con from '@services/connection'
import store from '@state/store'
import { removeAccents } from '@utils/Format'

class APIInstituicoes {
  async carregar() {
    if (store.getters['instituicoes/listaLoading']) {
      console.log('Ja esta carregando as instituicoes')
      return store.getters['instituicoes/lista']
    }

    store.dispatch('instituicoes/setListaLoading', true)

    const r = await con.get(adicionarTransacao.bancos.listar)

    if (r && r.status === 200) {
      store.dispatch('instituicoes/setLista', r.value)
    }

    store.dispatch('instituicoes/setListaLoading', true)

    return r || {}
  }

  /**
   * Metodo usado nos componentes de combobox para filtrar os itens
   */
  filtrar(item, queryText) {
    return (
      removeAccents((item.nome || '').toLowerCase()).includes(
        removeAccents((queryText || '').toLowerCase())
      ) || (item.codigo || item.codigo_corretora).toString().includes(queryText)
    )
  }

  formatarTexto(item) {
    const cod = item.codigo || item.codigo_corretora
    return `${cod ? cod + ' - ' : ''}${item.nome}`
  }
}

const apiInstituicoes = new APIInstituicoes()
export default apiInstituicoes
